import { ReportingProvider } from './context';
import { ReportingPage } from './page';
import { ErrorBoundary } from '../../components';

export const Reporting = () => (
  <ErrorBoundary translationNamespace="reports">
    <ReportingProvider>
      <ReportingPage />
    </ReportingProvider>
  </ErrorBoundary>
);
